import React, { useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
//Alert
import ErrorAlert from '../../Alerts/ErrorAlert';
const ManualConsiliation = ({ description, reference, date, amount, groupedTransactions, handleAssign, setJustification }) => {

    const [showModal, setShowModal] = useState(false);
    const [showJustificationModal, setShowJustificationModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');

    //Function to handle the file change
    const handleSelectedGroupChange = (e) => {
        setSelectedGroup(JSON.parse(e.target.value));
    };


    //Function to ask the user if the amount is correct
    const handleSubmit = () => {
        if (selectedGroup === null) {
            ErrorAlert("Por favor, selecciona un grupo de transacciones.", "Seleccionar grupo", "warning");
            return;
        }
        if (selectedGroup.total !== amount) {
            Swal.fire({
                title: '¿La cantidad es correcta?',
                text: `La cantidad seleccionada es ${selectedGroup.total.toFixed(2)}, pero la cantidad de la transacción es ${amount}.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'No, cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log("La cantidad es correcta, continuar con la asignación del lote.");
                    //We clean the justification and show the modal to add a justification
                    setJustification("");
                    setShowJustificationModal(true);
                }
            })
        } else {
            handleAssignGroup();
        }
    };

    //Function to asing the batch reference to the selected group
    const handleAssignGroup = () => {
        if (reference.trim() === "") return;

        // Asignar la referencia del lote a cada transacción del grupo seleccionado
        const updatedTransactions = selectedGroup.orders.map(order => ({
            ...order,
            consiliation: true,
            consiliationType: "Manual"
        }));

        handleAssign(selectedGroup.createdAt, selectedGroup.paymenthod, updatedTransactions, reference);
        setShowModal(false);
    }


    return (
        <>
            <div>
                <button className='btn btn-primary  btn-sm   '
                    onClick={() => (setShowModal(true))} >
                    <i class="uil uil-file-upload-alt"></i> Asignar lote manualmente
                </button>
            </div>


            <Modal size="md" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Body>
                    <div className=' position-relative'>
                        <div className='position-absolute top-0 start-100 translate-middle  '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" variant="secondary"
                                    onClick={() => setShowModal(false)} title='Cerrar'>
                                    <i class="uil uil-multiply"></i>
                                    <span class="visually-hidden">Dismiss</span>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center  mt-lg-2"> <i class="fa-solid fa-money-bill-transfer"></i> Importación de Lotes Manual</h2>
                        <div className=" p-2 bg-white rounded-3 mt-2">
                            <section >


                                <div className=' w-100 '>
                                    <div className='d-flex justify-content-between align-items-center mb-2'>
                                        <h6 className="fw-semibold">Transacción Seleccionada</h6>
                                    </div>
                                    <div class="card border border-light-subtle border-2 " role='button' >
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between">
                                                <div class="flex-column align-items-center">
                                                    <h5 class="card-text">{description}</h5>
                                                    <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {reference}</h6>
                                                </div>
                                                <div>

                                                    <span className='text-dark fw-semibold' ><span >{amount < 0 ? "Debito: " : "Credito: "} ${amount} </span> </span>

                                                </div>

                                            </div>

                                            <p class="card-text">Fecha:{date}</p>

                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center mt-2'>
                                    <h6 className="fw-semibold"> Listado de trasacciones</h6>
                                </div>
                                <div className='wrapper-bank p-2'>
                                    <div class="d-flex flex-column flex-md-row gap-2 align-items-center justify-content-center">
                                        <div class="list-group list-group-checkable d-grid gap-2 border-0 w-100">
                                            {
                                                groupedTransactions.map((group, idx) => (
                                                    <>
                                                        <input class="list-group-item-check pe-none" type="radio" name="listGroupCheckableRadios" id={"listGroupCheckableRadios" + idx} value={JSON.stringify(group)} onChange={(e) => { handleSelectedGroupChange(e) }} />
                                                        <label class="list-group-item rounded-3 py-3 w-100" for={"listGroupCheckableRadios" + idx} >
                                                            {group.createdAt}
                                                            <span class="d-block small opacity-50">Metodo de pago: {group.paymenthod}</span>
                                                            <span class="d-block small opacity-50">Total: ${group.total.toFixed(2)}</span>
                                                            <span class="d-block small opacity-50">Referencias:
                                                                {group.orders.map(element => {
                                                                    return <span key={element.transaction_code}> {element.transaction_code}, </span>
                                                                })}
                                                            </span>
                                                        </label>
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end align-items-center mt-2 gap-2'>
                                    <button className='btn btn-light text-secondary ' onClick={() => setShowModal(false)} title='Cerrar'>Cerrar </button>
                                    <button className='btn btn-save-sp' onClick={handleSubmit}>Guardar </button>
                                </div>


                            </section>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


            {/**Modal to add a justification  */}
            <Modal size="md" centered backdrop="static" show={showJustificationModal} onHide={() => { setShowJustificationModal(false); setJustification("") }}>
                <Modal.Header closeButton>
                    <Modal.Title>Agrega una Justificacion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label>Justificacion</Form.Label>
                    <textarea onChange={(e) => setJustification(e.target.value)} className='form-control' name="" id="" cols="30" rows="10"></textarea>
                    <Modal.Footer>
                        <button className="btn btn-light text-secondary" onClick={() => { setShowJustificationModal(false); setJustification("") }}>
                            Cancelar
                        </button>
                        <button className="btn btn-save-sp" onClick={() => {
                            handleAssignGroup();
                            setShowJustificationModal(false);
                        }
                        }>
                            Guardar
                        </button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>





        </>
    )
}

export default ManualConsiliation